import { render, staticRenderFns } from "./single-user-role.vue?vue&type=template&id=11d25bdb&scoped=true"
import script from "./single-user-role.vue?vue&type=script&lang=js"
export * from "./single-user-role.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d25bdb",
  null
  
)

export default component.exports